module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEIAAAAVCAYAAADy3zinAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAADSSURBVFhH7Zg7FoMwDAS5/9VC0gCHyKcJkMYuFJTYxA9FVs2igoatdp6RBzUhBPInUOMQvgdhBRFjpPxMr0htf6Pn9HuHmueDIECsEGYDAkj+FwRDOPd3Gisl0XIB4gNhMCAA5gJEDcJsQNpzLkCMS9lyIJaD8zI8CDVXh2UJg8ufuqs6MxByEwSXbDv9CkXJqyDcIxapco9IENA8YWvE237uEemXwj1CA4HqCTzzah5kXp/8bSF4guVBJggUT9BWCbmfe0TatwgQR99U+aou7WzfWXEKUq6yqQIAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/recruit.png
// module id = eg/m
// module chunks = 5